export { IPartnerMarketConfigService } from './interface';
export { PartnerMarketConfigService, Feature } from './partner-market-config.service';
